import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty, falsy } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { PROCESSING_PLANTS } from '../reducer';

function* getStateFromApi() {
    yield takeLatest(PROCESSING_PLANTS.GET_STATE_FROM_API, function* (action) {
        const response = yield apiRequest('api/v1/processingSites', { method: 'get' });
        yield put(apiSuccess(PROCESSING_PLANTS.GET_STATE_FROM_API_SUCCESS, response));
    });
}

function* createProcessingPlant() {
    yield takeLatest(PROCESSING_PLANTS.CREATE_PROCESSING_PLANT, function* (action) {
        yield put(appActions.setLoader('create-edit-processing-plant', true));
        const processedControls = {
            ...action.controls,
            name: action.controls.name.toUpperCase(),
        };
        const response = yield apiRequest('api/v1/processingSites', {
            method: 'post',
            body: JSON.stringify(processedControls),
        });
        if (truthty(response.error)) {
            yield put(appActions.setError(response.errorMsg));
        } else {
            yield put(apiSuccess(PROCESSING_PLANTS.CREATE_PROCESSING_PLANT_SUCCESS, response));
        }
        yield put(appActions.setLoader('create-edit-processing-plant', false));
    });
}

function* editProcessingPlant() {
    yield takeLatest(PROCESSING_PLANTS.EDIT_PROCESSING_PLANT, function* (action) {
        yield put(appActions.setLoader('create-edit-processing-plant', true));
        const processedControls = {
            ...action.controls,
            name: action.controls.name.toUpperCase(),
        };
        const response = yield apiRequest(`api/v1/processingSites/${action.id}`, {
            method: 'put',
            body: JSON.stringify(processedControls),
        });
        if (truthty(response.error)) {
            yield put(appActions.setError(response.errorMsg));
        } else {
            yield put(apiSuccess(PROCESSING_PLANTS.EDIT_PROCESSING_PLANT_SUCCESS, response));
        }
        yield put(appActions.setLoader('create-edit-processing-plant', false));
    });
}

function* deleteProcessingPlant() {
    yield takeLatest(PROCESSING_PLANTS.DELETE_PROCESSING_PLANT, function* (action) {
        yield put(appActions.setLoader('delete-processing-plant', true));
        const response = yield apiRequest(`api/v1/processingSites/${action.id}`, { method: 'delete' });
        if (falsy(response.error)) {
            const item = Object.values(response)[0];
            yield put(apiSuccess(PROCESSING_PLANTS.DELETE_PROCESSING_PLANT_SUCCESS, { item, type: 'processingSites' }));
        } else {
            yield put(appActions.setError(response.errorMsg));
        }
        yield put(appActions.setLoader('delete-processing-plant', false));
    });
}

export default function* saga() {
    yield spawn(getStateFromApi);
    yield spawn(deleteProcessingPlant);
    yield spawn(createProcessingPlant);
    yield spawn(editProcessingPlant);
}